import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import posthog from 'posthog-js';

const PostHogPageTracker = () => {
    const location = useLocation();

    useEffect(() => {
        posthog.capture('$pageview', {
            path: location.pathname,
            search: location.search,
        });

        console.log('Page View:', location.pathname);
    }, [location]);

    return null;
};

export default PostHogPageTracker;
